import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
declare var $: any;
import * as _ from 'lodash';
import { Sh10Service } from 'src/app/services/sh10.service';
var moment = require('moment');

@Component({
  selector: 'app-sh10list',
  templateUrl: './sh10list.component.html',
  styleUrls: ['./sh10list.component.css']
})
export class Sh10listComponent implements OnInit {

  public environmentSettings: any;
  id: any = null;
  isSearchDivVisible = false;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  deletebankdetails: any;
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  currentURL: any;
  response: boolean;
  deleteSH10Id: any;
  dateOfOpeningBBO:any;
  dateOfClosingBBO:any;
  editParticularId: any;

  constructor(private sh10: Sh10Service, private commonFunction: CommonFunction, private router: Router, 
    private alert: AlertComponent,private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');


    //this.getRegisterDirectorList();

    


    // this.router.navigate(['/bankparticulars/edit/_id']);

    // this.router.navigate(['/bankparticulars/add']);
    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [4] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'SH-10 List',
          title: 'SH-10 List',
          extend: 'excel',
          exportOptions: {
            columns: [0,1,2,3],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

    this.getsh10List();

    this.currentURL = window.location.href;


    var haseditpermisssion: any = false;
    if (this.currentURL.includes('edit') && !environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'edit');
    }
    else if (environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'add');
    }
    haseditpermisssion = false;
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  addsh10(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['sh-10','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  adjustdirectormasterTable() {
    var directorData = this.masterDirectorList;
    if (directorData.length) {
      this.masterDirectorList = [];
      $("#directormasterbankTable").DataTable().destroy();
      this.masterDirectorList = directorData;
      this.dtTriggerMasterDirector.next();
      setTimeout(() => {
        $("#directormasterbankTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#directormasterbankTable").DataTable().columns.adjust().draw();
    });
  }


  getsh10List() {
    this.registerDirectorList = [];
    this.sh10.getsh10details().subscribe(registerList => {
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
  }

  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null
    }
    this.sh10.generateSh10Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.sh10.downloadSh10File(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.sh10.downloadSh10PdfFile(id, 'Multi');
  }


  confirmDelete(id) {
    this.deleteSH10Id = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletesh10detail() {
    console.log(" sh10 delete ID ", this.deleteSH10Id);
    this.sh10.removesh10details(this.deleteSH10Id)
      .subscribe(response => {
        console.log("sh10  delete master ", response);
        if (response.status == 0) {
          // this.registerDirectorList = [];
          // this.getRegisterDirectorList();
          $("#mastersh10Table").DataTable().destroy();
          $("#deleteConfirm").modal('toggle');
          this.alert.success(response.message);
        } else {
          this.alert.error(response.message)
        }
        this.getsh10List();
      });
  }

  getRegisterDirectorList() {

    this.registerDirectorList = [];
    this.sh10.getsh10details().subscribe(registerList => {
      this.registerDirectorList = registerList.data;
    });
  }

  editsh10detail(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['sh-10','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['sh-10/edit/', _id]);
  }

  setTodate(ev) {
    var fromDate = new Date(this.commonFunction.setDate(ev));
    var setToDateByFromDate = new Date(moment(fromDate));
    this.futureToDate = { year: setToDateByFromDate.getFullYear(), month: setToDateByFromDate.getMonth() + 1, day: setToDateByFromDate.getDate() };
  }

  setFromdate(ev) {
    var toDate = new Date(this.commonFunction.setDate(ev));
    var setFromDateByToDate = new Date(moment(toDate));
    this.futureFromDate = { year: setFromDateByToDate.getFullYear(), month: setFromDateByToDate.getMonth() + 1, day: setFromDateByToDate.getDate() };
  }

  setDateDatepicker(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch(){
    this.response = true;
    var searchParam =
    {
      "dateofopeningbboffer": this.setDateDatepicker(this.dateOfOpeningBBO),
      'dateofclosingbb': this.setDateDatepicker(this.dateOfClosingBBO),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#mastersh10Table").DataTable().destroy();
    this.sh10.getModifySearchData(searchParam).subscribe(registerList => {
      this.response = false;
      if (registerList.status == 0) {
        this.registerDirectorList = registerList.data;
        this.dtTriggerRegisterDirector.next();
      }
    }); 
  }

  clearAdvSearch(){
    this.dateOfOpeningBBO = undefined;
    this.dateOfClosingBBO = undefined;
    $("#mastersh10Table").DataTable().destroy();
    this.getsh10List();
  }
}

